import { Location } from "./Location";
import { Product, ProductObject } from "./Product";
import { PurchaseRule } from "./PurchaseRule";
import { PurchaseRuleLink } from "./PurchaseRuleLink";

export enum MembershipUsageType {
    LIMITED = "limited",
    UNLIMITED = "unlimited",
}

export interface Membership extends Product {
    desc: string;
    price: number;
    currency: string;
    object: ProductObject.MEMBERSHIP;
    additionalBenefits?: string;
    meetingLocation?: Location;
    refundPolicy?: string;
    expiryInterval?: number;
    purchaseRule?: PurchaseRule;
    redemptionPurchaseRuleLink?: PurchaseRuleLink;
    redemptionPurchaseRule?: PurchaseRule;
    requireGuestIdentification?: boolean;
}
